import { render, staticRenderFns } from "./student_detail.vue?vue&type=template&id=f9ea36b0&scoped=true"
import script from "./student_detail.vue?vue&type=script&lang=js"
export * from "./student_detail.vue?vue&type=script&lang=js"
import style0 from "./student_detail.vue?vue&type=style&index=0&id=f9ea36b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ea36b0",
  null
  
)

export default component.exports